const TAB_KEY = 'workingHours'
export default {
  name: 'workingHours',

  computed: {
    workingHoursConfig () {
      return {
        title: this.$t('people/person.working_hours'),
        key: TAB_KEY,
        formData: this.formData,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'idCards', edit)
          this.$set(this.disableTabs, 'documents', edit)
          this.$set(this.disableTabs, 'violations', edit)
        },
        tabContent: [
          {
            component: this.workingHoursComponent
          }
        ]
      }
    }
  }
}
